import { useState } from "react";
import "./FAQ.css";
import React from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

function FAQ({ faq }) {
  const [isOpen, setIsOpen] = useState(faq.open || false);

  const toggle = () => {
    setIsOpen(!isOpen);

    console.log(isOpen);
  };

  return (
    <React.Fragment>
      <dt
        className="font-bold cursor-pointer"
        aria-expanded={isOpen ? "true" : "false"}
        onClick={toggle}
      >
        {`${!isOpen ? "+" : "="} ${faq.question} ${!isOpen ? "+" : "="}`}
      </dt>
      <dd className={!isOpen ? "hidden" : "mb-2"}>
        <BlocksRenderer
          className="faqblockrender"
          content={faq.answer}
          blocks={{
            list: ({ children, format }) => (
              <span className="list-disc list-inside">{children}</span>
            ),
          }}
        />
      </dd>
    </React.Fragment>
  );
}

export default FAQ;
